import { useTranslation } from 'react-i18next';
import { SmartAction } from '@connect-x-app/shared-domain-models';
import { Row, Table } from '@tanstack/react-table';

import { TableLayout } from '../../../../../../shared';

type Props = {
  deleteButtonDisabled: boolean;
  isAddButtonPresent: boolean;
  isDeleteButtonPresent: boolean;
  onAdd: () => void;
  onDelete: () => void;
  onRowClicked: (row: Row<SmartAction>) => void;
  rowClickAllowed: boolean;
  table: Table<SmartAction>;
};

export const CustomSmartActionsTable = ({
  deleteButtonDisabled,
  isAddButtonPresent,
  isDeleteButtonPresent,
  onAdd,
  onDelete,
  onRowClicked,
  rowClickAllowed,
  table,
}: Props) => {
  const { t } = useTranslation();

  return (
    <TableLayout
      addButtonAction={onAdd}
      addButtonLabel={t('SMART_ACTIONS_ADD_BUTTON')}
      deleteButtonAction={onDelete}
      deleteButtonDisabled={deleteButtonDisabled}
      hasProportionalColumns
      isAddButtonPresent={isAddButtonPresent}
      isCollapsableTable
      isDeleteButtonPresent={isDeleteButtonPresent}
      noRowsMessage={t('SMART_ACTIONS_TABLE_NO_ROWS')}
      onRowClicked={onRowClicked}
      rowClickAllowed={rowClickAllowed}
      table={table}
      titleText={t('SMART_ACTION.TABLES.CUSTOM_TITLE')}
    />
  );
};
